import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function BerechnungsartDurchschnitt() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.durchschnitt',
        )}
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.label',
        )}
        item={
          data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.zusammenfassungSuffix',
          )
        }
      />
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.label',
        )}
        item={
          <span>
            {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger
              .unbezahlteUeberstundenMonat ?? '00:00'}
            {` ${t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.zusammenfassungSuffix',
            )}`}
          </span>
        }
      />
    </>
  );
}
